const quotes = [

{
    quote: "Focus on being productive instead of busy.",
    author: "Tim Ferriss, American entrepreneur"
},
{
    quote: "Productivity is being able to do things that you were never able to do before.",
    author: "Franz Kafka, novelist"
},
{
    quote: "There is little that the human mind can conceive that is not possible of accomplishment",
    author: "Charles Schwab, famous business leader"
},
{
    quote: "Edit your life frequentyl and ruthlessly. It's your masterpiece after all.",
    author: "Nathan W. Morris, author"
},
{
    quote: "You miss 100% of the shots you don’t take",
    author: "Wayne Gretzky, Canadian former professional ice hockey player"
},
{
    quote: "Simplicity boils down to two steps: Identify the essential. Eliminate the rest.",
    author: "Leo Babauta, blogger"
},
{
    quote: "Strive not to be a success, but rather to be of value.",
    author: "Albert Einstein, German theoretical physicist"
},
{
    quote: "Sometimes, things may not go your way, but the effort should be there every single night.",
    author: "Michael Jordan, American basketball player"
},
{
    quote: "The tragedy in life doesn’t lie in not reaching your goal. The tragedy lies in having no goal to reach.",
    author: "Benjamin E. Mays, American civil rights leader"
},
{
    quote: "If you spend too much time thinking about a thing, you’ll never get it done.",
    author: "Bruce Lee, actor"
},
{
    quote: "Until we can manage time, we can manage nothing else.",
    author: "Peter Drucker, management consultant"
},

]

export default quotes;